module.exports = __webpack_public_path__ + "img/PL08762.55a22b2e.png";